module.exports = __webpack_public_path__ + "static/media/Portfolio.23d9b1e7.png";